import { API } from '../helpers/fetcher'

export const omnioBalanceCheck = async params =>
  API.post('v1/omnio/balance', params)

export const omnioAuthentication = async params =>
  API.post('v1/omnio/authorisation', params)
